<template>
    <a href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym" :class="typeClass" target="_blank">
        <i class="fa-brands fa-whatsapp wa-my-float"></i>
    </a>
</template>

<script>

export default {
    components: {},

    props: {
        typeClass: {default: 'wa-float-circle'}
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
.wa-float{
    position:fixed;
    width:36px;
    height:36px;
    background-color:#198754;
    color:#FFF;
    border-radius:10px;
    text-align:center;
    font-size:24px;
    box-shadow: 2px 2px 3px #999;
    z-index:100;
}


.wa-float-circle {
    position:fixed;
    width:60px;
    height:60px;
    bottom:40px;
    right:40px;
    background-color:#198754;
    color:#FFF;
    border-radius:50px;
    text-align:center;
    font-size:30px;
    box-shadow: 2px 2px 3px #999;
    z-index:100;
}

.wa-float:hover {
    color: #198754;
    background-color: white;
}

.wa-float-circle {
    .wa-my-float{
        margin-top:16px;
    }
}
</style>
